// Reviews slider — "Lees meer" per card + full-review modal. Cards clamp
// their text to 3 lines (line-clamp-3 in the template); the toggle only
// shows when a review actually overflows the clamp. Clicking it opens the
// modal (same shell/behaviour as the quick view) filled from that card.
(function ($) {
  $(function () {
    const $modal = $('#phent-review-modal');
    if (!$modal.length) return;

    function open() {
      $modal.removeClass('hidden').attr('aria-hidden', 'false');
      $('body').addClass('overflow-hidden');
      requestAnimationFrame(() => $modal.addClass('is-open'));
    }

    function close() {
      $modal.removeClass('is-open').attr('aria-hidden', 'true');
      $('body').removeClass('overflow-hidden');
      setTimeout(() => $modal.addClass('hidden'), 300);
    }

    // Show the toggle only on reviews that overflow the 3-line clamp. Runs
    // after the owl init in slider.js (ready handlers fire in import order),
    // so cloned slides are covered too; re-run on load/resize for reflows.
    function checkOverflow() {
      document.querySelectorAll('.phent-review-card .phent-review-text').forEach((text) => {
        const toggle = text.parentElement.querySelector('.phent-review-readmore');
        if (!toggle) return;
        const overflows = text.scrollHeight > text.clientHeight + 1;
        toggle.classList.toggle('hidden', !overflows);
        toggle.classList.toggle('inline-flex', overflows);
      });
    }
    checkOverflow();
    $(window).on('load', checkOverflow);
    let resizeTimer;
    $(window).on('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(checkOverflow, 150);
    });

    $(document).on('click', '.phent-review-readmore', function () {
      const $card = $(this).closest('.phent-review-card');
      const $stars = $card.find('.phent-review-stars');
      $modal.find('.phent-review-modal__stars').html($stars.html()).attr('aria-label', $stars.attr('aria-label'));
      $modal.find('.phent-review-modal__text').html($card.find('.phent-review-text').html());
      const name = $card.find('.phent-review-name').text();
      $modal.find('.phent-review-modal__name').text(name).toggleClass('hidden', !name);
      open();
    });

    $modal.on('click', '.phent-review-modal__close', close);
    $modal.on('mousedown', function (e) {
      if (!$(e.target).closest('.phent-review-modal__box').length) close();
    });
    $(document).on('keydown', function (e) {
      if (e.key === 'Escape' && $modal.hasClass('is-open')) close();
    });
  });
})(jQuery);
